<template lang="pug">
b-sidebar(position="static", :mobile="mobile", type="is-white", open)
    .block.p-1
        img(src="@/assets/logo.png")
    b-menu(:activable="false")
        b-menu-list(icon-pack="fas", label="Main")
            b-menu-item(label="Home", :active="active === 'Home'", @click="updatePage('Home')")
              b-menu-item(label="Profile", :active="active === 'Profile'", @click="updatePage('Profile')")
              b-menu-item(label="Calendar", :active="active === 'Calendar'", @click="updatePage('Calendar')")
              b-menu-item(label="Weather", :active="active === 'Weather'", @click="updatePage('Weather')")
              b-menu-item(label="AP Poll", :active="active === 'AP Poll'", @click="updatePage('AP Poll')")
              b-menu-item(label="Requirements", :active="active === 'Requirements'", @click="updatePage('Requirements')")
              b-menu-item(label="Settings", :active="active === 'Settings'", @click="updatePage('Settings')")
        b-menu-list(icon-pack="fas", label="Tenting")
            b-menu-item(label="Tent Check", :active="active === 'Tent Check'", @click="updatePage('Tent Check')")
              b-menu-item(label="Text", :active="active === 'Text'", @click="updatePage('Text')")
              b-menu-item(label="Form", :active="active === 'Form'", @click="updatePage('Form')")
              b-menu-item(label="Check History", :active="active === 'Check History'", @click="updatePage('Check History')")
              b-menu-item(label="Attendance Events", :active="active === 'Attendance Events'", @click="updatePage('Attendance Events')")
              b-menu-item(label="Statistics", :active="active === 'Tenting Statistics'", @click="updatePage('Tenting Statistics')")
        b-menu-list(icon-pack="fas", label="Gameday")
            b-menu-item(label="Gameday", :active="active === 'Gameday'", @click="updatePage('Gameday')")
              b-menu-item(label="Statistics", :active="active === 'Gameday Statistics'", @click="updatePage('Gameday Statistics')")
        b-menu-list(icon-pack="fas", label="Admin")
            b-menu-item(label="Users", :active="active === 'Users'", @click="updatePage('Users')")
              b-menu-item(label="Rosters", :active="active === 'Rosters'", @click="updatePage('Rosters')")
              b-menu-item(label="Email", :active="active === 'Email'", @click="updatePage('Email')")
              b-menu-item(label="Misses", :active="active === 'Misses'", @click="updatePage('Misses')")
        b-menu-list(icon-pack="fas", label="Actions")
            b-menu-item(label="Logout", @click="logoutUser")             
</template>

<script>
export default {
  name: "Sidebar",

  data: function() {
    return {
      mobile: "hidden",

      active: "Home"
    };
  },

  methods: {
    // Log out the user
    logoutUser() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },

    updatePage(page) {
      this.active = page;
      this.$emit("update:active", page);
    }
  }
};
</script>
